import { compose, withProps } from "recompose";
import {
	GoogleMap,
	Marker,
	withGoogleMap,
	withScriptjs,
} from "react-google-maps";
import { useState } from "react";

const MyMap = compose(
	withProps({
		googleMapURL: `https://maps.googleapis.com/maps/api/js?v=3.exp&libraries=geometry,drawing,places&key=${process.env.REACT_APP_GOOGLE_MAP_KEY}`,
		loadingElement: <div style={{ height: `100%` }} />,
		containerElement: (
			<div
				style={{
					height: `400px`,
					border: "2px solid var(--primary-color)",
					borderRadius: "25px",
					padding: "0",
					overflow: "hidden",
				}}
			/>
		),
		mapElement: <div style={{ height: `100%` }} />,
	}),
	withScriptjs,
	withGoogleMap
)((props) => {
	const [lat, setLat] = useState(
		props.lat ?? parseFloat(process.env.REACT_APP_MAP_LAT)
	);
	const [lng, setLng] = useState(
		props.lng ?? parseFloat(process.env.REACT_APP_MAP_LNG)
	);
	const pinLocationChanged = (e) => {
		setLat(e.latLng.lat());
		setLng(e.latLng.lng());
		props.updateLocationPositions(e.latLng.lat(), e.latLng.lng());
	};
	return (
		<GoogleMap defaultZoom={12} defaultCenter={{ lat: lat, lng: lng }}>
			<Marker
				draggable={props.draggable}
				onMouseOut={props.onMouseOut ? pinLocationChanged : null}
				position={{ lat: lat, lng: lng }}
			/>
		</GoogleMap>
	);
});

export default MyMap;
